export interface IUser {
  id: number;
  company: string;
  creditBalance: number;
  helperSubmitted: boolean;
  disclaimerSubmitted: boolean;
  email: string;
  isSuperUser: boolean;
  phone: string;
  locale: string;
  name: string;
  proIsActive: boolean;
  role: string;
  avatar: string;
  uuid: string;
  consent: Record<string, string>;
  projectRoles?: string[];
  isRoleMaster?: boolean;
}

export type UserPlan = 'guest' | 'free' | 'standart' | 'professional' | 'enterprice';

export const DefaultUser: IUser = {
  avatar: "",
  company: "",
  creditBalance: 0,
  disclaimerSubmitted: false,
  email: "",
  helperSubmitted: false,
  id: 0,
  isSuperUser: false,
  locale: "",
  name: "",
  phone: "",
  proIsActive: false,
  role: "",
  uuid: '',
  consent: {},
  projectRoles: [],
  isRoleMaster: false,
}
